import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const CounterBtn = ({
  counter, counterState
}) => {

  return (
    <>
      {counter >= 1 && (
        <div className={cn(styles.bgColorLight, 'w-40 d-flex justify-content-between align-items-center')}>
          <button type="button" className={cn('btn-secondary od-dec-font-btn-color od-dec-counter-btn-color fs-10 btn-secondary', styles.btnStyle)} onClick={() => { counterState(-1, 'dec'); }} aria-label="minusBtn">
            <i className="fas fa-minus va-m" />
          </button>
          <div className={cn('d-flex justify-content-center align-items-center fs-24')} style={{ marginTop: 4, width: 50 }}>
            {counter}
          </div>
          <button type="button" className={cn('od-inc-font-btn-color od-inc-counter-btn-color fs-10 btn-secondary', styles.btnStyle)} onClick={() => { counterState(1, 'inc'); }} aria-label="plusBtn">
            <i className="fas fa-plus va-m" />
          </button>
        </div>
      )}
    </>
  );
};

export default CounterBtn;
